<app-main-content-card>
  <div class="title-bar">
    <h1>{{ "SEGMENT_DISCOUNTS.TITLE" | translate }}</h1>
  </div>
  <div class="table-container">
    <table *ngrxLet="editRowIndex$ as editRowIndex">
      <thead>
        <tr class="mat-header-row caption-row">
          <th class="mat-header-cell">
            {{ "VIP_DISCOUNTS.SETTINGS.PRODUCT" | translate }}
          </th>
          <th class="mat-header-cell">
            {{ "VIP_DISCOUNTS.SETTINGS.DISCOUNT" | translate }}
          </th>
          <th class="mat-header-cell">
            {{ "VIP_DISCOUNTS.SETTINGS.DATE_FROM" | translate }}
          </th>
          <th class="mat-header-cell">
            {{ "VIP_DISCOUNTS.SETTINGS.DATE_TO" | translate }}
          </th>
          <th class="mat-header-cell"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container
          *ngFor="
            let merchantType of availableMerchantsForSegmentDiscount;
            let i = index
          "
        >
          <tr class="empty-row">
            <td colspan="5"></td>
          </tr>
          <tr class="body-header-row">
            <td class="header-cell" colspan="5">
              {{ "MERCHANT.TYPE_CATEGORIZED." + merchantType | translate }}
            </td>
          </tr>
          <tr
            *ngFor="
              let productDiscount of (discountGroups$ | async)[merchantType];
              let j = index
            "
          >
            <td class="mat-cell">
              {{
                "PRODUCT_TYPE." +
                  (j < 5
                    ? "ALCOHOLIC_DRINK_TYPE."
                    : "NON_ALCOHOLIC_DRINK_TYPE.") +
                  productDiscount.productType | translate
              }}
            </td>
            <ng-container
              *ngIf="editRowIndex !== i + '|' + j; else discountForm"
            >
              <td class="mat-cell input-cell">
                {{
                  productDiscount.id ? productDiscount.discountValue + "%" : ""
                }}
              </td>
              <td class="mat-cell input-cell">
                {{ productDiscount.startDate | date: "YYYY.MM.dd." }}
              </td>
              <td class="mat-cell input-cell">
                {{
                  productDiscount.endDate === cancellationMockDate
                    ? ("DISCOUNTS.UNTIL_CANCELLATION" | translate)
                    : (productDiscount.endDate | date: "YYYY.MM.dd.")
                }}
              </td></ng-container
            >
            <ng-template #discountForm>
              <ng-container [formGroup]="formGroup">
                <td class="mat-cell input-cell">
                  <div class="discount-cell easy-form">
                    <mat-form-field class="value-field">
                      <div
                        class="form-field-container value-field"
                        [class.warning]="
                          formGroup.get('discountValue')?.invalid &&
                          formGroup.get('discountValue')?.touched
                        "
                      >
                        <input
                          class="prefix suffix"
                          matInput
                          formControlName="discountValue"
                          type="number"
                          (wheel)="$event.preventDefault()"
                          step="1"
                          min="0"
                          max="99"
                          appLimitDecimalDigits
                          [decimals]="2"
                          [isNumberInput]="true"
                        />
                        <span matTextSuffix>%</span>
                      </div>
                    </mat-form-field>
                  </div>
                </td>
                <td class="mat-cell input-cell">
                  <div class="easy-form">
                    <mat-form-field>
                      <div class="form-field-container">
                        <input
                          formControlName="startDate"
                          [matDatepicker]="pickerFrom"
                          class="suffix"
                          matInput
                          [min]="minStartDate"
                          (focus)="pickerFrom.open()"
                        />
                        <span matSuffix (click)="pickerFrom.open()">
                          <mat-icon>today</mat-icon>
                        </span>
                        <mat-datepicker #pickerFrom></mat-datepicker>
                      </div>
                    </mat-form-field>
                  </div>
                </td>
                <td class="mat-cell input-cell">
                  <div class="easy-form">
                    <mat-form-field>
                      <div class="form-field-container">
                        <input
                          formControlName="endDate"
                          [matDatepicker]="pickerTo"
                          class="suffix"
                          matInput
                          [min]="
                            formGroup.get('startDate')?.value
                              ? formGroup.get('startDate')?.value
                              : today
                          "
                          (focus)="pickerTo.open()"
                        />
                        <span matSuffix (click)="pickerTo.open()">
                          <mat-icon>today</mat-icon>
                        </span>
                        <mat-datepicker #pickerTo></mat-datepicker>
                      </div>
                    </mat-form-field>
                  </div>
                </td>
              </ng-container>
            </ng-template>

            <td class="mat-cell">
              <div class="actions">
                <ng-container
                  *ngIf="
                    productDiscount.id || editRowIndex === i + '|' + j;
                    else emptyDiscount
                  "
                >
                  <ng-container
                    *ngIf="editRowIndex !== i + '|' + j; else editingButtons"
                  >
                    <button
                      type="button"
                      mat-icon-button
                      color="primary"
                      class="stroked"
                      [disabled]="editRowIndex !== ''"
                      (click)="editDiscount(i, j, productDiscount)"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      type="button"
                      color="warn"
                      class="stroked"
                      mat-icon-button
                      (click)="deleteDiscount(productDiscount)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </ng-container>
                  <ng-template #editingButtons>
                    <button
                      type="button"
                      color="primary"
                      mat-icon-button
                      class="stroked"
                      (click)="saveDiscount(productDiscount)"
                    >
                      <mat-icon>save</mat-icon>
                    </button>
                    <button
                      type="button"
                      mat-icon-button
                      class="stroked"
                      (click)="cancelEdit()"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
                <ng-template #emptyDiscount>
                  <button
                    type="button"
                    mat-icon-button
                    class="stroked"
                    color="primary"
                    [disabled]="editRowIndex !== ''"
                    (click)="editDiscount(i, j, productDiscount)"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </ng-template>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</app-main-content-card>
